(function() {
  'use strict';
  
  function sortSizes(buttons) {
    return Array.from(buttons).sort((a, b) => {
      const sizeA = a.textContent.trim();
      const sizeB = b.textContent.trim();
      
      const numA = parseInt(sizeA);
      const numB = parseInt(sizeB);
      
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
      
      const alphabeticalOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
      const indexA = alphabeticalOrder.indexOf(sizeA.toUpperCase());
      const indexB = alphabeticalOrder.indexOf(sizeB.toUpperCase());
      
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      
      if (!isNaN(numA) && indexB !== -1) return -1;
      if (!isNaN(numB) && indexA !== -1) return 1;
      
      if (!isNaN(numA) && isNaN(numB)) return -1;
      if (!isNaN(numB) && isNaN(numA)) return 1;
      
      if (indexA !== -1 && indexB === -1) return -1;
      if (indexB !== -1 && indexA === -1) return 1;
      
      return sizeA.localeCompare(sizeB);
    });
  }
  
  function reorderContainer(container) {
    if (!container || container.dataset.sorted === 'true' || container.dataset.preOrdered === 'true') return;
    
    const buttons = container.querySelectorAll('.variant-button');
    if (buttons.length <= 1) return;
    
    const currentOrder = Array.from(buttons).map(btn => btn.textContent.trim()).join(',');
    
    const sortedButtons = sortSizes(buttons);
    const newOrder = sortedButtons.map(btn => btn.textContent.trim()).join(',');
    
    if (currentOrder !== newOrder) {
      sortedButtons.forEach(button => {
        container.appendChild(button);
      });
      
      container.dataset.sorted = 'true';
      setTimeout(() => {
        delete container.dataset.sorted;
      }, 100);
    }
  }
  
  function forceVariantSorting() {
    const containers = document.querySelectorAll('.variant-buttons');
    containers.forEach(reorderContainer);
  }
  
  forceVariantSorting();
  
  const sortingInterval = setInterval(forceVariantSorting, 500);
  
  const observer = new MutationObserver(function(mutations) {
    let shouldSort = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.classList?.contains('variant-buttons') || 
                node.querySelector?.('.variant-buttons')) {
              shouldSort = true;
            }
          }
        });
      }
    });
    
    if (shouldSort) {
      setTimeout(forceVariantSorting, 50);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  const events = ['DOMContentLoaded', 'load', 'resize', 'scroll'];
  events.forEach(event => {
    window.addEventListener(event, () => {
      setTimeout(forceVariantSorting, 100);
    });
  });
  
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      setTimeout(forceVariantSorting, 200);
      return response;
    });
  };
  
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(...args) {
    this.addEventListener('load', () => {
      setTimeout(forceVariantSorting, 200);
    });
    return originalOpen.apply(this, args);
  };
  
  window.forceSortVariants = forceVariantSorting;
  
  window.stopVariantSorting = function() {
    clearInterval(sortingInterval);
    observer.disconnect();
  };
  
})();